import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    height: null,
  },
  error: {
    marginTop: 20,
  },
  icon: {
    marginRight: 5,
  },
  label: {
    alignSelf: 'center',
  },
  loadingContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
    marginBottom: 30,
  },
  infoContainer: {
    paddingHorizontal: 20,
    marginTop: 16,
  },
  infoText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    fontWeight: 'normal',
    lineHeight: 22.9,
  },
  infoPhone: {
    fontSize: 16.6,
    fontWeight: 'bold',
    lineHeight: 22.9,
  },
  infoChangeNumberContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: 16.6,
  },
  infoChangeNumber: theme => ({
    color: theme.colors.hyperlinkFive,
    fontSize: 16.6,
    fontWeight: 'normal',
    lineHeight: 22.9,
    paddingTop: 3,
    paddingHorizontal: 4,
  }),
  loadingText: loginColors => ({
    color: loginColors.loadingText,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    paddingTop: Platform.OS === 'ios' ? 3 : null,
  }),
  textLabel: isDisabled => ({
    color: Colors.smoothGrey,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 22.9,
    opacity: isDisabled ? 0.5 : 1,
  }),
  resendLabelWrapper: {
    marginBottom: 30,
  },
  resendWithCounterContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 30,
  },
});
